import React from 'react';

import { Icon } from '../icons';

export const EditSmlIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M18.1628016,5.8048249 L26.1329183,13.7749416 L8.82614786,31.0817121 L1.72015564,31.8661479 C0.768871595,31.9713619 -0.0348638132,31.1670039 0.0709727626,30.2157198 L0.861634241,23.1047471 L18.1628016,5.8048249 Z M31.0624125,4.61821012 L27.3201556,0.875953307 C26.1528405,-0.291361868 24.2596109,-0.291361868 23.0922957,0.875953307 L19.5716732,4.39657588 L27.5417899,12.3666926 L31.0624125,8.84607004 C32.2297276,7.6781323 32.2297276,5.78552529 31.0624125,4.61821012 Z" />
    </svg>
  );
};
